module.exports = __webpack_public_path__ + "static/img/icon-userdetail-inter3.e08fccaf.png";